const contributors = await fetch("/contributors.json")
  .then(response => response.json())
  .catch(error => console.log(error));


const {affiliations, funding} = await fetch("/logos.json")
  .then(response => response.json())
  .catch(error => console.log(error));

const capitalizeFirstLetter = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
)

const ProfileCard = ({contributor}) => {
  const {name, affiliation, orcid, mail, picture, roles} = contributor;
  return (
    <div className="card mb-3" style={{maxWidth:  '560px'}}>
      <div className="row g-0">
        <div className="col-md-3">
          <img src={picture} className="img-fluid rounded-start" alt="profile-picture" />
        </div>
        <div className="col-md-9">
          <div className="card-body">
            <h5 className="card-title">
              {name}
              &nbsp;
              <small>
                <a className="col" href={orcid}
                  style={{color: "inherit", textDecoration: "inherit"}}>
                  <i className="fa-brands fa-orcid" />
                </a>
                &nbsp;
                <a className="col" href={`mailto:${mail}?subject=Fatty Acylizer`}
                  style={{color: "inherit", textDecoration: "inherit"}}>
                  <i className="fa-solid fa-envelope" />
                </a>
              </small>
            </h5>
            <p className="card-text">
              <small className="text-muted">
                {affiliation}
              </small>
            </p>
            <p className="card-text">
              {capitalizeFirstLetter(roles.join(', '))}
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const Logo = ({src}) => {
  return (
    <div className="col">
      <img src={src} style={{height: 100}}/>
    </div>
  )
}


export const WhoAreWe = () => (
  <>
    <h2>Contributors</h2>
    {contributors.map((contributor, i) => <ProfileCard contributor={contributor} key={i}/>)}
    <h2>Affiliations</h2>
    <div className="row">
      {affiliations.map((logo, i) => <Logo src={logo.url} key={i}/>)}
    </div>
    <h2>Funding</h2>
    <div className="row">
      {funding.map((logo, i) => <Logo src={logo.url} key={i}/>)}
    </div>
  </>
)
